<div class="progress-bar-container">
  <div
    class="tw-inline-flex tw-h-[250px] tw-w-[320px] tw-flex-col tw-items-center tw-gap-4 tw-rounded-xl tw-bg-dt-surface-elevated tw-px-12 tw-py-10"
  >
    <div class="tw-flex tw-gap-2">
      <div class="tw-text-base tw-font-medium">{{ pendingState()?.message }}</div>
    </div>

    @if (pendingState()?.progress > 0) {
      <div
        class="tw-flex tw-h-28 tw-w-28 tw-items-center tw-justify-center tw-rounded-full tw-border-2 tw-border-dt-border-tertiary"
      >
        <div
          class="tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center tw-rounded-full tw-to-neutral-50 tw-p-2"
          [ngStyle]="{ background: background() }"
        >
          <div
            class="tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center tw-rounded-full tw-bg-dt-surface-elevated"
          >
            <div>...</div>
          </div>
        </div>
      </div>

      @if (pendingState().step) {
        <div class="tw-text-center">
          <span class="tw-font-semibold tw-text-dt-text-action">step</span>
          <span class="tw-font-medium">{{ pendingState().step }}</span>
        </div>
      }
    } @else {
      <svg
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 200 200"
        width="150"
        height="150"
      >
        <defs>
          <filter [attr.id]="uid + '-bloom'" x="-80%" y="-80%" width="260%" height="260%">
            <feGaussianBlur in="SourceGraphic" stdDeviation="6" />
          </filter>
          <filter [attr.id]="uid + '-disc-glow'" x="-40%" y="-40%" width="180%" height="180%">
            <feGaussianBlur in="SourceGraphic" stdDeviation="2.5" result="blur" />
            <feMerge>
              <feMergeNode in="blur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <filter [attr.id]="uid + '-core-glow'" x="-60%" y="-60%" width="220%" height="220%">
            <feGaussianBlur in="SourceGraphic" stdDeviation="3" result="b" />
            <feMerge>
              <feMergeNode in="b" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <filter [attr.id]="uid + '-plate-shadow'" x="-12%" y="-10%" width="124%" height="135%">
            <feDropShadow dx="0" dy="5" stdDeviation="12" flood-color="rgba(0,150,180,0.13)" />
          </filter>
          <radialGradient [attr.id]="uid + '-plate-bg'" cx="38%" cy="33%" r="68%">
            <stop offset="0%" stop-color="rgba(255,255,255,0.97)" />
            <stop offset="100%" stop-color="rgba(218,245,250,0.90)" />
          </radialGradient>
          <linearGradient [attr.id]="uid + '-plate-rim'" x1="14%" y1="14%" x2="86%" y2="86%">
            <stop offset="0%" stop-color="rgba(255,255,255,0.95)" />
            <stop offset="45%" stop-color="rgba(0,188,212,0.16)" />
            <stop offset="100%" stop-color="rgba(255,255,255,0.60)" />
          </linearGradient>
          <radialGradient [attr.id]="uid + '-fg-t'" cx="33%" cy="28%" r="72%">
            <stop offset="0%" stop-color="rgba(255,255,255,0.95)" />
            <stop offset="55%" stop-color="rgba(178,236,244,0.78)" />
            <stop offset="100%" stop-color="rgba(0,172,193,0.55)" />
          </radialGradient>
          <radialGradient [attr.id]="uid + '-fg-o'" cx="33%" cy="28%" r="72%">
            <stop offset="0%" stop-color="rgba(255,255,255,0.95)" />
            <stop offset="55%" stop-color="rgba(255,236,179,0.78)" />
            <stop offset="100%" stop-color="rgba(245,124,0,0.55)" />
          </radialGradient>
          <radialGradient [attr.id]="uid + '-core-glass'" cx="38%" cy="32%" r="66%">
            <stop offset="0%" stop-color="rgba(255,255,255,0.98)" />
            <stop offset="100%" stop-color="rgba(200,240,246,0.84)" />
          </radialGradient>
          <radialGradient [attr.id]="uid + '-ambient'" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stop-color="rgba(0,188,212,0.08)" />
            <stop offset="100%" stop-color="rgba(0,188,212,0)" />
          </radialGradient>
        </defs>
        <g class="svg-root">
          <circle
            cx="100"
            cy="100"
            r="92"
            [attr.fill]="'url(#' + uid + '-plate-bg)'"
            [attr.filter]="'url(#' + uid + '-plate-shadow)'"
          />
          <circle cx="100" cy="100" r="78" [attr.fill]="'url(#' + uid + '-ambient)'" />
          <ellipse
            cx="74"
            cy="63"
            rx="32"
            ry="15"
            fill="rgba(255,255,255,0.52)"
            transform="rotate(-28,74,63)"
            class="shimmer"
          />
          <ellipse
            cx="130"
            cy="145"
            rx="20"
            ry="9"
            fill="rgba(0,188,212,0.07)"
            transform="rotate(-28,130,145)"
            class="sh2"
          />
          <circle
            cx="100"
            cy="100"
            r="92"
            fill="none"
            [attr.stroke]="'url(#' + uid + '-plate-rim)'"
            stroke-width="1.5"
          />
          <circle
            cx="100"
            cy="100"
            r="89.5"
            fill="none"
            stroke="rgba(0,188,212,0.09)"
            stroke-width="0.6"
          />
          <circle
            cx="100"
            cy="100"
            r="80"
            fill="none"
            stroke="rgba(0,188,212,0.10)"
            stroke-width="0.8"
            stroke-dasharray="3 7"
          />
          <circle
            cx="100"
            cy="100"
            r="62"
            fill="none"
            stroke="rgba(245,124,0,0.10)"
            stroke-width="0.8"
            stroke-dasharray="3 7"
          />
          <circle
            cx="100"
            cy="100"
            r="44"
            fill="none"
            stroke="rgba(0,188,212,0.10)"
            stroke-width="0.8"
            stroke-dasharray="3 7"
          />
          <g class="r-out">
            <g class="d1">
              <circle
                cx="180"
                cy="100"
                r="11"
                fill="rgba(0,188,212,0.28)"
                [attr.filter]="'url(#' + uid + '-bloom)'"
              />
              <circle
                cx="180"
                cy="100"
                r="9"
                [attr.fill]="'url(#' + uid + '-fg-t)'"
                [attr.filter]="'url(#' + uid + '-disc-glow)'"
              />
              <circle
                cx="180"
                cy="100"
                r="9"
                fill="none"
                stroke="rgba(255,255,255,0.88)"
                stroke-width="1.2"
              />
              <circle
                cx="180"
                cy="100"
                r="9"
                fill="none"
                stroke="rgba(0,188,212,0.30)"
                stroke-width="0.5"
              />
              <ellipse cx="177" cy="97" rx="4.2" ry="2.6" fill="rgba(255,255,255,0.72)" />
              <circle cx="176.5" cy="96.8" r="1.4" fill="rgba(255,255,255,0.96)" />
            </g>
            <g class="d2">
              <circle
                cx="60"
                cy="169.3"
                r="11"
                fill="rgba(0,188,212,0.28)"
                [attr.filter]="'url(#' + uid + '-bloom)'"
              />
              <circle
                cx="60"
                cy="169.3"
                r="9"
                [attr.fill]="'url(#' + uid + '-fg-t)'"
                [attr.filter]="'url(#' + uid + '-disc-glow)'"
              />
              <circle
                cx="60"
                cy="169.3"
                r="9"
                fill="none"
                stroke="rgba(255,255,255,0.88)"
                stroke-width="1.2"
              />
              <circle
                cx="60"
                cy="169.3"
                r="9"
                fill="none"
                stroke="rgba(0,188,212,0.30)"
                stroke-width="0.5"
              />
              <ellipse cx="57" cy="166.3" rx="4.2" ry="2.6" fill="rgba(255,255,255,0.72)" />
              <circle cx="56.5" cy="166.1" r="1.4" fill="rgba(255,255,255,0.96)" />
            </g>
            <g class="d3">
              <circle
                cx="60"
                cy="30.7"
                r="11"
                fill="rgba(0,188,212,0.28)"
                [attr.filter]="'url(#' + uid + '-bloom)'"
              />
              <circle
                cx="60"
                cy="30.7"
                r="9"
                [attr.fill]="'url(#' + uid + '-fg-t)'"
                [attr.filter]="'url(#' + uid + '-disc-glow)'"
              />
              <circle
                cx="60"
                cy="30.7"
                r="9"
                fill="none"
                stroke="rgba(255,255,255,0.88)"
                stroke-width="1.2"
              />
              <circle
                cx="60"
                cy="30.7"
                r="9"
                fill="none"
                stroke="rgba(0,188,212,0.30)"
                stroke-width="0.5"
              />
              <ellipse cx="57" cy="27.7" rx="4.2" ry="2.6" fill="rgba(255,255,255,0.72)" />
              <circle cx="56.5" cy="27.5" r="1.4" fill="rgba(255,255,255,0.96)" />
            </g>
          </g>
          <g class="r-mid">
            <g class="d4">
              <circle
                cx="162"
                cy="100"
                r="9.5"
                fill="rgba(245,124,0,0.28)"
                [attr.filter]="'url(#' + uid + '-bloom)'"
              />
              <circle
                cx="162"
                cy="100"
                r="7.5"
                [attr.fill]="'url(#' + uid + '-fg-o)'"
                [attr.filter]="'url(#' + uid + '-disc-glow)'"
              />
              <circle
                cx="162"
                cy="100"
                r="7.5"
                fill="none"
                stroke="rgba(255,255,255,0.88)"
                stroke-width="1.2"
              />
              <circle
                cx="162"
                cy="100"
                r="7.5"
                fill="none"
                stroke="rgba(245,124,0,0.30)"
                stroke-width="0.5"
              />
              <ellipse cx="159.4" cy="97.4" rx="3.6" ry="2.2" fill="rgba(255,255,255,0.72)" />
              <circle cx="159" cy="97.2" r="1.2" fill="rgba(255,255,255,0.96)" />
            </g>
            <g class="d5">
              <circle
                cx="69"
                cy="153.7"
                r="9.5"
                fill="rgba(245,124,0,0.28)"
                [attr.filter]="'url(#' + uid + '-bloom)'"
              />
              <circle
                cx="69"
                cy="153.7"
                r="7.5"
                [attr.fill]="'url(#' + uid + '-fg-o)'"
                [attr.filter]="'url(#' + uid + '-disc-glow)'"
              />
              <circle
                cx="69"
                cy="153.7"
                r="7.5"
                fill="none"
                stroke="rgba(255,255,255,0.88)"
                stroke-width="1.2"
              />
              <circle
                cx="69"
                cy="153.7"
                r="7.5"
                fill="none"
                stroke="rgba(245,124,0,0.30)"
                stroke-width="0.5"
              />
              <ellipse cx="66.4" cy="151.1" rx="3.6" ry="2.2" fill="rgba(255,255,255,0.72)" />
              <circle cx="66" cy="150.9" r="1.2" fill="rgba(255,255,255,0.96)" />
            </g>
            <g class="d4">
              <circle
                cx="69"
                cy="46.3"
                r="9.5"
                fill="rgba(245,124,0,0.28)"
                [attr.filter]="'url(#' + uid + '-bloom)'"
              />
              <circle
                cx="69"
                cy="46.3"
                r="7.5"
                [attr.fill]="'url(#' + uid + '-fg-o)'"
                [attr.filter]="'url(#' + uid + '-disc-glow)'"
              />
              <circle
                cx="69"
                cy="46.3"
                r="7.5"
                fill="none"
                stroke="rgba(255,255,255,0.88)"
                stroke-width="1.2"
              />
              <circle
                cx="69"
                cy="46.3"
                r="7.5"
                fill="none"
                stroke="rgba(245,124,0,0.30)"
                stroke-width="0.5"
              />
              <ellipse cx="66.4" cy="43.7" rx="3.6" ry="2.2" fill="rgba(255,255,255,0.72)" />
              <circle cx="66" cy="43.5" r="1.2" fill="rgba(255,255,255,0.96)" />
            </g>
          </g>
          <g class="r-inn">
            <g class="d6">
              <circle
                cx="100"
                cy="144"
                r="8"
                fill="rgba(0,188,212,0.24)"
                [attr.filter]="'url(#' + uid + '-bloom)'"
              />
              <circle
                cx="100"
                cy="144"
                r="6"
                [attr.fill]="'url(#' + uid + '-fg-t)'"
                [attr.filter]="'url(#' + uid + '-disc-glow)'"
              />
              <circle
                cx="100"
                cy="144"
                r="6"
                fill="none"
                stroke="rgba(255,255,255,0.90)"
                stroke-width="1.1"
              />
              <circle
                cx="100"
                cy="144"
                r="6"
                fill="none"
                stroke="rgba(0,188,212,0.28)"
                stroke-width="0.5"
              />
              <ellipse cx="97.8" cy="141.8" rx="3" ry="1.8" fill="rgba(255,255,255,0.70)" />
              <circle cx="97.5" cy="141.6" r="1" fill="rgba(255,255,255,0.96)" />
            </g>
            <g class="d7">
              <circle
                cx="100"
                cy="56"
                r="8"
                fill="rgba(0,188,212,0.24)"
                [attr.filter]="'url(#' + uid + '-bloom)'"
              />
              <circle
                cx="100"
                cy="56"
                r="6"
                [attr.fill]="'url(#' + uid + '-fg-t)'"
                [attr.filter]="'url(#' + uid + '-disc-glow)'"
              />
              <circle
                cx="100"
                cy="56"
                r="6"
                fill="none"
                stroke="rgba(255,255,255,0.90)"
                stroke-width="1.1"
              />
              <circle
                cx="100"
                cy="56"
                r="6"
                fill="none"
                stroke="rgba(0,188,212,0.28)"
                stroke-width="0.5"
              />
              <ellipse cx="97.8" cy="53.8" rx="3" ry="1.8" fill="rgba(255,255,255,0.70)" />
              <circle cx="97.5" cy="53.6" r="1" fill="rgba(255,255,255,0.96)" />
            </g>
          </g>
          <circle
            cx="100"
            cy="100"
            r="25"
            fill="none"
            stroke="rgba(0,188,212,0.20)"
            stroke-width="1"
            class="pulse"
          />
          <circle
            cx="100"
            cy="100"
            r="19"
            [attr.fill]="'url(#' + uid + '-core-glass)'"
            class="pulse"
          />
          <circle
            cx="100"
            cy="100"
            r="19"
            fill="none"
            stroke="rgba(255,255,255,0.88)"
            stroke-width="1.5"
            class="pulse"
          />
          <circle
            cx="100"
            cy="100"
            r="19"
            fill="none"
            stroke="rgba(0,188,212,0.18)"
            stroke-width="0.6"
            class="pulse"
          />
          <circle
            cx="100"
            cy="100"
            r="10"
            fill="rgba(245,124,0,0.18)"
            [attr.filter]="'url(#' + uid + '-core-glow)'"
            class="pulse"
          />
          <circle
            cx="100"
            cy="100"
            r="6"
            fill="#F57C00"
            [attr.filter]="'url(#' + uid + '-core-glow)'"
          />
          <circle cx="100" cy="100" r="3.8" fill="#FFE082" />
          <circle cx="97.5" cy="97.5" r="2" fill="rgba(255,255,255,0.92)" />
          <ellipse
            cx="95"
            cy="93"
            rx="6.5"
            ry="3.8"
            fill="rgba(255,255,255,0.48)"
            transform="rotate(-20,95,93)"
          />
        </g>
      </svg>
    }
  </div>
</div>
